export const parseEndTime = (endTime: string): number => {
  return Number(`${endTime}000`);
};
